// Author Lin
// Date 2021-11-06 10:05:06

class MintalMesMstGeneratorSet {
constructor({
        id = null,
        locationId = '',
        locationName = '',
        generatorCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.locationName = locationName;
    this.generatorCode = generatorCode;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesMstGeneratorSet();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationId',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.grid.locationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'generatorCode',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.grid.generatorCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    locationIdFilter : '',
    locationNameFilter : '',
    generatorCodeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationNameFilter',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                }
        },
        {
        key: 'generatorCodeFilter',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.filter.generatorCode',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                }
        },
        {
        key: 'generatorCode',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.entity.generatorCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstGeneratorSet.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesMstGeneratorSet, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
